import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { PrimitiveObject } from "../../services/ApiPlatform/types";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class TypologyApi extends EntityApi {
    protected static GET_COLLECTION = "/api/typologies";

    protected static POST_COLLECTION = "/api/typologies";

    protected static GET_ITEM = "/api/typologies/{id}";

    protected static PUT_ITEM = "/api/typologies/{id}";

    protected static PATCH_ITEM = "/api/typologies/{id}";

    protected static DELETE_ITEM = "/api/typologies/{id}";

    protected static GET_COLLECTION_FOR_SELECT = "/api/typologies/select";

    public static async getCollectionForSelect<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_FOR_SELECT,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
